import { fg } from '@atlassian/jira-feature-gating';

export const checkIfOlderThanNDays = (productStartTimestamp?: string, days = 7) => {
	if (!productStartTimestamp) {
		return false;
	}

	const daysInMs = fg('polaris_reduce_spotlight_wait_for_qa')
		? 3 * 60 * 1000
		: days * 24 * 60 * 60 * 1000;
	const currentDate = new Date();
	const productAge = currentDate.getTime() - new Date(productStartTimestamp).getTime();
	return productAge > daysInMs;
};
